import type { BillingNeededActionItem } from 'src/redux/billing/billing.types';
import type { BillingActionNeeded } from './billing-dashboard.types';

function formatLabelPart(raw: string): string {
  if (!raw) return '';
  return raw
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Maps API rows to the billing dashboard strip. The API does not send a free-text description;
 * we derive concise copy from entity type and integration fields.
 */
function manageClientsHref(tab: 'manage-accounts' | 'manage-campaigns', title: string): string {
  const params = new URLSearchParams();
  params.set('attention_needed', 'true');
  if (title.trim()) {
    params.set('search', title.trim());
  }
  return `/manage-clients/${tab}?${params.toString()}`;
}

export function mapBillingNeededActionToUi(item: BillingNeededActionItem): BillingActionNeeded {
  if (item.entity_type === 'account') {
    return {
      id: item.id,
      description: `Review billing for this advertiser account (${formatLabelPart(item.source)}).`,
      affectedRecord: `Account: ${item.title}`,
      resolveHref: manageClientsHref('manage-accounts', item.title),
      resolveLabel: 'Open accounts',
    };
  }

  return {
    id: item.id,
    description: `Review billing for this campaign (${formatLabelPart(item.platform)} · ${formatLabelPart(item.channel)}).`,
    affectedRecord: `Campaign: ${item.title}`,
    resolveHref: manageClientsHref('manage-campaigns', item.title),
    resolveLabel: 'Open campaigns',
  };
}
